import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  // Auth uses Bearer tokens via Authorization header (set by request interceptor below);
  // no cookies are read client-side, so leaving withCredentials at its default (false)
  // matches the permissive CORS config (allow_origins=*, allow_credentials=false).
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sirh_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      if (window.location.pathname !== "/login") {
        localStorage.removeItem("sirh_token");
        localStorage.removeItem("sirh_user");
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
